import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ICommentMentionedUser } from '../comments/model/comment.model';

@Pipe({
  name: 'mentionLink',
  standalone: true,
})
export class MentionLinkPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(text: string, mentions: ICommentMentionedUser[] = []): SafeHtml {
    if (!text || !mentions.length) return text;
    // Sort mentions by start index descending to avoid messing up indices
    const sortedMentions = [...mentions].sort((a, b) => b.start - a.start);
    let result = text;
    sortedMentions.forEach((mention) => {
      const mentionText = text.substring(mention.start, mention.end);
      // Replace only at the correct position
      result = `${result.slice(
        0,
        mention.start
      )}<b class="mention-link">${mentionText}</b>${result.slice(mention.end)}`;
    });
    return this.sanitizer.bypassSecurityTrustHtml(result);
  }
}
